import BaseModel from './BaseModel';

class ProjectDraftEditLock extends BaseModel {
  hasActiveLock() {
    return !!this.editLock;
  }

  getHolderUserId() {
    return this.editLock ? this.editLock.holderUserId : null;
  }

  getHolderDisplayName() {
    return this.editLock ? this.editLock.holderDisplayName : '';
  }

  getCheckedOutAt() {
    return this.editLock ? this.editLock.checkedOutAt : null;
  }

  getEditorSessionId() {
    return this.editLock ? this.editLock.editorSessionId : null;
  }

  getPendingTakeover() {
    return (this.editLock && this.editLock.pendingTakeover) || null;
  }
}

ProjectDraftEditLock.collection = 'projectDrafts';

export default ProjectDraftEditLock;
